import { CTA, Container, HandLeftIcon, Link, Logo } from '~/components'
import { Exhibitor as ExhibitorFeature } from '~/features/exhibitors/Exhibitor'
import { ExhibitorStory } from '../types'

import * as styles from './ExhibitorScreen.css'

type Props = {
  exhibitor: ExhibitorStory
}

export function ExhibitorScreen({ exhibitor }: Props) {
  return (
    <div css={styles.wrapper}>
      <Container>
        <div css={styles.header}>
          <div css={styles.headerBrand}>
            <Link href="/">
              <Logo css={styles.logo} />
            </Link>
          </div>
          <div css={styles.headerAction}>
            <CTA href="/" icon={<HandLeftIcon css={styles.actionIcon} />} css={styles.actionButton}>
              zurück zur Übersicht
            </CTA>
          </div>
        </div>
      </Container>

      <ExhibitorFeature exhibitor={exhibitor} />
    </div>
  )
}
